import { formatPercentage as o } from "../../../helpers/formatting/formatPercentage.js";
import { formatDate as f, formatShortDate as m } from "../../../helpers/formatting/formatDate.js";
import { formatCurrency as p } from "../../../helpers/formatting/formatCurrency.js";
import { formatISODateTime as c, formatRelativeTime as u } from "../../../helpers/formatting/formatDateTime.js";
const y = ({
  currencyCode: t = "$",
  currencyFormatOptions: i,
  format: e,
  row: n,
  value: r
}) => e ? typeof e == "function" ? e(r, n) : e === "currency" ? `${t}${p({
  value: r,
  ...i
})}` : e === "number" ? typeof r == "number" ? r : Number(r) : e === "date" ? f(r) : e === "shortDate" ? m(r) : e === "isoDateTime" ? c(r) : e === "relativeTime" ? u(r) : e === "percent" ? o(r) : r : r;
export {
  y as IressTableFormattedValue
};
